import React, { useRef, useState, useEffect } from 'react';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import styled from 'styled-components';

import { ArrowLeft, ArrowRight } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

const Carousel = ({
  children,
  slidesToShow,
  slidesToScroll,
  addSlideMargin = false, // this should be depreciated
  slideMargin = '0px',
  variableWidth = false,
  smallIcon = false,
  className = '',
  onNext = () => {},
  ...props
}) => {
  const customSlider = useRef(null);

  const [currentPage, setCurrentPage] = useState(0);
  const [maxPages, setMaxPages] = useState(0);
  const [settings, setSettings] = useState({
    infinite: false,
    slidesToShow,
    slidesToScroll,
    initialSlide: 0,
    speed: 500,
    arrows: false,
    draggable: false,
    variableWidth,
    className: variableWidth ? 'slider variable-width' : '',
    ...props,
  });
  useEffect(() => {
    const count = children.length;
    const itemsPerPage = Math.floor(slidesToShow);

    if (count) {
      setMaxPages(Math.ceil(count / itemsPerPage) - 1);
    }
  }, [children.length, slidesToShow]);

  useEffect(() => {
    setSettings((state) => ({ ...state, slidesToShow, slidesToScroll }));
  }, [slidesToScroll, slidesToShow]);

  const gotoNext = () => {
    onNext();
    customSlider.current.slickNext();
    setCurrentPage(currentPage + 1);
  };

  const gotoPrev = () => {
    customSlider.current.slickPrev();
    setCurrentPage(currentPage - 1);
  };

  return (
    <SliderContainer className={className}>
      {currentPage !== 0 && <CarouselButton onClick={gotoPrev} left StartIcon={ArrowLeft} />}
      {currentPage < maxPages && <CarouselButton onClick={gotoNext} right StartIcon={ArrowRight} />}

      <StyledSlider {...settings} ref={customSlider} slideMargin={addSlideMargin ? '1.5rem' : slideMargin}>
        {children}
      </StyledSlider>
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledSlider = styled(Slider)`
  .slick-list > div {
    margin-left: 0;
  }

  // display flex and height inherit of .slick-slide is to make child height 100%.
  .slick-track {
    display: flex;
    align-items: stretch;
  }

  .slick-slide {
    height: inherit;
    flex: ${(props) => (props.stretchChildren ? 1 : 'unset')};
    margin-left: ${(props) => props.slideMargin};

    &:first-child {
      margin-left: 0;
    }

    // making heights of div 100% so that children can attain 100% height.
    & > div {
      height: 100%;

      // setting children height to 100% - 1px in case they have shadows.
      > * {
        // height: calc(100% - 1px);
        display: ${(props) => (props.stretchChildren ? 'flex !important' : 'test-block')};

        // to remove the focus outline
        &:focus {
          outline: none;
        }
      }
    }
  }
`;

const CarouselButton = styled(Button)`
  width: 20px !important;
  height: 20px !important;
  border-radius: 50% !important;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
  svg {
    color: white;
  }
  position: absolute !important;
  top: 53%;
  z-index: 9;
  transform: translateY(-56%);
  ${({ right }) =>
    right &&
    `
    right: 1rem;
  `};
  ${({ left }) =>
    left &&
    `
    left: 0rem;
  `};
`;

export default Carousel;
